import React from 'react';
import { Summary } from "../../Summary";
export var getSummaryMarkup = function getSummaryMarkup(_ref) {
  var areOnlyNightPriceAndRatingDisplayed = _ref.areOnlyNightPriceAndRatingDisplayed,
      locationName = _ref.locationName,
      periodText = _ref.periodText,
      pricePerPeriod = _ref.pricePerPeriod,
      pricePerPeriodPrefix = _ref.pricePerPeriodPrefix,
      propertyName = _ref.propertyName,
      ratingNumber = _ref.ratingNumber,
      isShowingPlaceholder = _ref.isShowingPlaceholder;
  return React.createElement(Summary, {
    areOnlyNightPriceAndRatingDisplayed: areOnlyNightPriceAndRatingDisplayed,
    isShowingPlaceholder: isShowingPlaceholder,
    locationName: locationName,
    periodText: periodText,
    pricePerPeriod: pricePerPeriod,
    pricePerPeriodPrefix: pricePerPeriodPrefix,
    propertyName: propertyName,
    ratingNumber: ratingNumber
  });
};